import { ColorPicker as ColorPickerComponent } from '@syncfusion/ej2-inputs';
import { addClass } from '@syncfusion/ej2-base';
import { spreadsheetDestroyed, fontColor, fillColor, beforeRibbonCreate, locale, focus } from '../common/index';
import { setCellFormat } from '../../workbook/common/index';
/**
 * `Color Picker` module is used to handle ColorPicker functionality.
 *
 * @hidden
 */
export class ColorPicker {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    render() {
        const id = this.parent.element.id;
        let input = this.parent.createElement('input', { attrs: { 'type': 'color' } });
        const tileRenderHandler = (args) => {
            args.element.tabIndex = -1;
        };
        this.fontColorPicker = new ColorPickerComponent({
            value: '#000000ff',
            mode: 'Palette',
            showButtons: false,
            presetColors: fontColor,
            enableOpacity: false,
            enableRtl: this.parent.enableRtl,
            cssClass: 'e-spreadsheet-color-popup',
            beforeTileRender: tileRenderHandler,
            beforeClose: () => this.beforeCloseHandler(this.fontColorPicker),
            open: this.openHandler.bind(this),
            beforeModeSwitch: (args) => this.beforeModeSwitch(this.fontColorPicker, args),
            change: (args) => {
                const color = this.fontColorPicker.getValue(args.currentValue.rgba);
                const eventArgs = { style: { color: color }, onActionUpdate: true };
                this.parent.notify(setCellFormat, eventArgs);
                if (eventArgs.cancel) {
                    this.fontColorPicker.setProperties({ 'value': this.fontColorPicker.getValue(args.previousValue.rgba, 'HEXA') }, true);
                }
                else {
                    this.updateSelectedColor(eventArgs.style.color, this.fontColorPicker.element, 'TextColor');
                }
            },
            created: () => this.updateSelectedColor('#000000', this.fontColorPicker.element, 'TextColor', true)
        });
        this.fontColorPicker.createElement = this.parent.createElement;
        this.parent.element.appendChild(input);
        this.fontColorPicker.appendTo(input);
        input.parentElement.id = `${id}_font_color_picker`;
        addClass([input.nextElementSibling.getElementsByClassName('e-selected-color')[0]], ['e-icons', 'e-font-color']);
        input = this.parent.createElement('input', { attrs: { 'type': 'color' } });
        this.filColorPicker = new ColorPickerComponent({
            value: '#ffff00ff',
            mode: 'Palette',
            presetColors: fillColor,
            showButtons: false,
            enableOpacity: false,
            enableRtl: this.parent.enableRtl,
            cssClass: 'e-spreadsheet-color-popup',
            open: this.openHandler.bind(this),
            beforeTileRender: tileRenderHandler,
            beforeClose: () => this.beforeCloseHandler(this.filColorPicker),
            beforeModeSwitch: (args) => this.beforeModeSwitch(this.filColorPicker, args),
            change: (args) => {
                const color = this.filColorPicker.getValue(args.currentValue.rgba);
                const eventArgs = { style: { backgroundColor: color }, onActionUpdate: true };
                this.parent.notify(setCellFormat, eventArgs);
                if (eventArgs.cancel) {
                    this.filColorPicker.setProperties({ 'value': this.filColorPicker.getValue(args.previousValue.rgba, 'HEXA') }, true);
                }
                else {
                    this.updateSelectedColor(eventArgs.style.backgroundColor, this.filColorPicker.element, 'FillColor');
                }
            },
            created: () => this.updateSelectedColor('#ffff00', this.filColorPicker.element, 'FillColor', true)
        });
        this.filColorPicker.createElement = this.parent.createElement;
        this.parent.element.appendChild(input);
        this.filColorPicker.appendTo(input);
        input.parentElement.id = `${id}_fill_color_picker`;
        addClass([input.nextElementSibling.getElementsByClassName('e-selected-color')[0]], ['e-icons', 'e-fill-color']);
    }
    updateSelectedColor(color, ele, name, isCreated) {
        const localeText = this.parent.serviceLocator.getService(locale).getConstant(name);
        if (isCreated) {
            ele.parentElement.querySelector('.e-dropdown-btn').setAttribute('aria-label', localeText);
        }
        const primaryBtn = ele.parentElement.querySelector('.e-split-colorpicker');
        primaryBtn.setAttribute('aria-label', `${localeText} ${color}`);
        primaryBtn.firstElementChild.style.borderBottomColor = color;
    }
    openHandler(args) {
        args.element.querySelector('.e-mode-switch-btn').title =
            this.parent.serviceLocator.getService(locale).getConstant('MoreColors');
    }
    beforeCloseHandler(inst) {
        if (!inst.modeSwitcher) {
            inst.setProperties({ modeSwitcher: true }, true);
        }
        if (inst.showButtons) {
            inst.setProperties({ showButtons: false }, true);
        }
        focus(inst.element.parentElement.querySelector('.e-split-colorpicker'));
    }
    beforeModeSwitch(inst, args) {
        const l10n = this.parent.serviceLocator.getService(locale);
        if (args.mode === 'Picker') {
            inst.showButtons = true;
            inst.dataBind();
            args.element.querySelector('.e-apply').title = l10n.getConstant('Apply');
            args.element.querySelector('.e-cancel').title = l10n.getConstant('Cancel');
            args.element.querySelector('.e-mode-switch-btn').title = l10n.getConstant('StandardColors');
        }
        else {
            inst.showButtons = false;
            inst.dataBind();
            args.element.querySelector('.e-mode-switch-btn').title = l10n.getConstant('MoreColors');
        }
    }
    destroy() {
        if (this.parent) {
            this.removeEventListener();
            if (this.fontColorPicker) {
                this.fontColorPicker.destroy();
            }
            this.fontColorPicker = null;
            if (this.filColorPicker) {
                this.filColorPicker.destroy();
            }
            this.filColorPicker = null;
            this.parent = null;
        }
    }
    addEventListener() {
        this.parent.on(beforeRibbonCreate, this.render, this);
        this.parent.on('destroyRibbonComponents', this.destroy, this);
        this.parent.on(spreadsheetDestroyed, this.destroy, this);
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(beforeRibbonCreate, this.render);
            this.parent.off('destroyRibbonComponents', this.destroy);
            this.parent.off(spreadsheetDestroyed, this.destroy);
        }
    }
}
